import { useEffect } from 'react'
import { useEditorStore } from '../../stores/editorStore'

/**
 * Erros do editor.
 *
 * Fica no rodapé e some sozinho: um erro de comando não deve interromper a edição com
 * um modal, mas também não pode passar despercebido.
 */
export function Toasts() {
  const error = useEditorStore((s) => s.error)
  const setError = useEditorStore((s) => s.setError)

  useEffect(() => {
    if (!error) return
    const timer = window.setTimeout(() => setError(null), 6000)
    return () => window.clearTimeout(timer)
  }, [error, setError])

  if (!error) return null

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 max-w-md">
      <div className="flex items-start gap-3 rounded-lg border border-danger/40 bg-danger-soft px-4 py-3 shadow-lg">
        <span className="text-danger text-sm leading-snug">{error}</span>
        <button
          className="text-ink-400 hover:text-ink-100 text-xs shrink-0"
          onClick={() => setError(null)}
          aria-label="Fechar"
        >
          ✕
        </button>
      </div>
    </div>
  )
}
